<template>
  <v-container>
    <v-form ref="form_prospect">
      <v-row>
        <v-col cols="12" xl="6" lg="6" md="6">
          <v-row class="mt-1">
            <v-col class="pb-0">
              <v-text-field
                :label="translations.label_company_name"
                background-color="white"
                outlined
                v-model="form.companyName"
                clearable
                dense
                :rules="validation(translations.field_required)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="primary--text font-weight-bold">
                {{ translations.label_contact_information }}
              </span>
            </v-col>
          </v-row>
          <v-row
            class="mb-0"
            v-if="user.role == 'SAMPLER_SOLENA' || user.role == 'GEN_MANAGER'"
          >
            <v-col class="pb-0">
              <v-autocomplete
                :label="translations.label_zone"
                background-color="white"
                outlined
                v-model="form.zone"
                clearable
                :items="zones"
                item-text="name"
                dense
                return-object
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mb-0">
            <v-col class="pb-0" cols="12">
              <v-text-field
                :label="translations.cultivableArea"
                background-color="white"
                outlined
                v-model="form.cultivableArea"
                clearable
                dense
              >
              </v-text-field>
            </v-col>
            <v-col class="pb-0">
              <v-text-field
                :label="translations.label_contact_name"
                background-color="white"
                outlined
                :rules="validation(translations.field_required)"
                v-model="form.name"
                clearable
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col class="py-0">
              <v-text-field
                :label="translations.email_label"
                background-color="white"
                v-model="form.email"
                :rules="validation(translations.field_required)"
                outlined
                clearable
                type="email"
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col class="py-0">
              <label class="v-label theme--light" style="font-size: 12px">
                {{ translations.label_phone }}
              </label>
              <vue-tel-input
                ref="phoneInput"
                v-model="form.phone"
                v-bind="telOptions"
                @onInput="onPhoneInput"
                class="custom-tel-input"
              ></vue-tel-input>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col class="py-0">
              <v-text-field
                :label="translations.label_rfc"
                v-model="form.tin"
                @keyup="uppercase"
                background-color="white"
                outlined
                clearable
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="6">
          <v-row>
            <v-col>
              <span class="primary--text font-weight-bold">
                {{ translations.label_address }}
              </span>
            </v-col>
          </v-row>
          <v-row class="mb-0">
            <v-col class="pb-0">
              <v-text-field
                :label="translations.label_street"
                background-color="white"
                outlined
                v-model="form.street"
                clearable
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="5" class="py-0">
              <v-text-field
                :label="translations.label_postal_code"
                background-color="white"
                outlined
                v-model="zipCode"
                clearable
                dense
                type="text"
              >
              </v-text-field>
            </v-col>
            <v-col class="py-0">
              <v-text-field
                :label="translations.label_exterior_number"
                background-color="white"
                outlined
                v-model="form.n_ext"
                clearable
                dense
              >
              </v-text-field>
            </v-col>
            <v-col class="py-0">
              <v-text-field
                :label="translations.label_interior_number"
                background-color="white"
                v-model="form.n_int"
                outlined
                clearable
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col class="py-0">
              <v-combobox
                :label="translations.label_neighborhood"
                background-color="white"
                outlined
                clearable
                dense
                v-model="suburb"
                return-object
                item-text="name"
                :items="countryList"
                hide-no-data
              >
              </v-combobox>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col class="py-0">
              <v-autocomplete
                :label="translations.label_country || 'País'"
                background-color="white"
                outlined
                v-model="form.country"
                :items="standardCountries"
                :item-text="(item) => item[currentLanguage] || item.es"
                item-value="val"
                clearable
                dense
                :rules="[validation(translations.field_required), validationCountry]"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col class="py-0">
              <v-text-field
                :label="translations.label_city"
                v-model="form.city"
                background-color="white"
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col class="pt-0">
              <v-text-field
                :label="translations.label_state"
                background-color="white"
                v-model="form.state"
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <ConfirmZone
      :title="translations.label_no_zone_assigned"
      v-model="showConfirmZone"
      @confirmation="saveDataWithoutZone"
    />
  </v-container>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
// Validations
import {
  requiredValidation,
  requiredFValidation,
} from "@/helpers/validations.js";
//components
import ConfirmZone from "@/components/utils/GenericModal.vue";
import standardCountries from "@/constants/countries.json";
export default {
  components: {
    ConfirmZone,
  },
  data: () => ({
    zipCode: "",
    suburb: "",
    countryList: [],
    standardCountries,
    zones: [],
    form: {
      name: "",
      email: "",
      phone: "",
      tin: "",
      companyName: "",
      street: "",
      n_ext: "",
      n_int: "",
      city: "",
      country: "",
      state: "",
      cultivableArea: "",
    },
    user: JSON.parse(localStorage.getItem("user")),
    showConfirmZone: false,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations", "currentLanguage"]),
    translations() {
      return this.currentTranslations;
    },
    telOptions() {
      return {
        mode: "international",
        defaultCountry: "MX",
        inputOptions: {
          placeholder: this.translations.label_phone || "",
          showDialCode: true,
        },
      };
    },
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapActions("user", [
      "getZipCode",
      "getClientById",
      "updateClient",
      "getZones",
    ]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    goBack() {
      this.$router.back();
    },
    onPhoneInput(formatted, phoneObject) {
      if (phoneObject && phoneObject.number) {
        this.form.phone = phoneObject.number.e164 || formatted;
      }
    },
    async saveData() {
      // Forzar el formato internacional antes de guardar
      if (this.$refs.phoneInput && this.$refs.phoneInput.phoneObject) {
        const { number } = this.$refs.phoneInput.phoneObject;
        if (number && number.e164) {
          this.form.phone = number.e164;
        }
      }
      if (this.$refs.form_prospect.validate()) {
        try {
          let request = {
            prospect: {
              billingInformation: {
                taxId: this.form.tin,
                companyName: this.form.companyName,
              },
              name: this.form.name,
              phone: this.form.phone,
              email: this.form.email,
              address: {
                city: this.form.city,
                country: this.form.country,
                exteriorNumber: this.form.n_ext,
                interiorNumber: this.form.n_int,
                state: this.form.state,
                street: this.form.street,
                suburb: this.suburb ? this.suburb.name : "",
                zipCode: this.zipCode,
              },
              cultivableArea: this.form.cultivableArea,
            },
          };
          if (
            this.user.role == "SAMPLER_SOLENA" ||
            this.user.role == "GEN_MANAGER"
          ) {
            if (this.form.zone) {
              request.prospect.zone = this.form.zone._id;
              this.SET_LOADER(true);
              let response = null;
              if (this.$route.params.id) {
                request.prospect._id = this.$route.params.id;
                response = await this.updateClient(request);
              }
              if (response) {
                if ((response.success = 1)) {
                  this.SET_LOADER(false);
                  if (this.$route.params.id) {
                    this.SET_ALERT_TYPE({
                      visible: true,
                      type: "success",
                      text: this.translations.label_client_updated,
                      timeout: 1000,
                    });
                  } else {
                    this.SET_ALERT_TYPE({
                      visible: true,
                      type: "success",
                      text: this.translations.label_client_created,
                      timeout: 1000,
                    });
                  }

                  this.goBack();
                } else {
                  this.SET_LOADER(false);
                  console.log(response.message);
                  this.SET_ALERT_TYPE({
                    visible: true,
                    type: "error",
                    text: this.translations.advice_error,
                    timeout: 4000,
                  });
                }
              } else {
                this.SET_LOADER(false);
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.advice_error,
                  timeout: 4000,
                });
              }
            } else {
              this.showConfirmZone = true;
            }
          } else {
            this.SET_LOADER(true);
            let response = null;
            if (this.$route.params.id) {
              request.prospect._id = this.$route.params.id;
              response = await this.updateClient(request);
            }
            if (response) {
              if ((response.success = 1)) {
                this.SET_LOADER(false);
                if (this.$route.params.id) {
                  this.SET_ALERT_TYPE({
                    visible: true,
                    type: "success",
                    text: this.translations.label_client_updated,
                    timeout: 1000,
                  });
                } else {
                  this.SET_ALERT_TYPE({
                    visible: true,
                    type: "success",
                    text: this.translations.label_client_created,
                    timeout: 1000,
                  });
                }

                this.goBack();
              } else {
                this.SET_LOADER(false);
                console.log(response.message);
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.advice_error,
                  timeout: 4000,
                });
              }
            } else {
              this.SET_LOADER(false);
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          }
        } catch (e) {
          this.SET_LOADER(false);
          console.log(e);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      }
    },
    async saveDataWithoutZone() {
      try {
        let request = {
          prospect: {
            billingInformation: {
              taxId: this.form.tin,
              companyName: this.form.companyName,
            },
            name: this.form.name,
            phone: this.form.phone,
            email: this.form.email,
            address: {
              city: this.form.city,
              country: this.form.country,
              exteriorNumber: this.form.n_ext,
              interiorNumber: this.form.n_int,
              state: this.form.state,
              street: this.form.street,
              suburb: this.suburb ? this.suburb.name : "",
              zipCode: this.zipCode,
            },
            cultivableArea: this.form.cultivableArea,
          },
        };

        this.SET_LOADER(true);
        let response = null;
        if (this.$route.params.id) {
          request.prospect._id = this.$route.params.id;
          response = await this.updateClient(request);
        }
        if (response) {
          if ((response.success = 1)) {
            this.SET_LOADER(false);
            if (this.$route.params.id) {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: this.translations.label_client_updated,
                timeout: 1000,
              });
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: this.translations.label_client_created,
                timeout: 1000,
              });
            }

            this.goBack();
          } else {
            this.SET_LOADER(false);
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_LOADER(false);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        this.SET_LOADER(false);
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    uppercase() {
      this.form.tin = this.form.tin.toUpperCase();
    },
    validation(value) {
      return requiredValidation(value);
    },
    validationCountry(value) {
      if (!value) return true;
      const isValid = this.standardCountries.some((c) => c.val === value);
      return isValid || "País no válido";
    },
    validationF(value) {
      return requiredFValidation(value);
    },
    async getZonesRequest() {
      try {
        let response = await this.getZones();
        if (!response) throw response;
        this.zones = response.zones;
      } catch (error) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
  },
  async mounted() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
      rightButton: "save",
      funcRightButton: this.saveData,
    });
    await this.getZonesRequest();
    if (this.$route.params.id) {
      try {
        let response = await this.getClientById({ id: this.$route.params.id });
        if (response) {
          if (!response.error) {
            this.form.name = response.client.companyName;
            this.form.email = response.client.email;
            this.form.phone = response.client.phone;
            this.form.tin = response.client.billingInformation
              ? response.client.billingInformation.taxId
              : "";
            this.form.companyName = response.client.billingInformation
              ? response.client.billingInformation.companyName
              : "";
            this.form.street = response.client.address
              ? response.client.address.street
              : "";
            this.zipCode = response.client.address
              ? response.client.address.zipCode
              : "";
            this.form.n_ext = response.client.address
              ? response.client.address.exteriorNumber
              : "";
            this.form.n_int = response.client.address
              ? response.client.address.interiorNumber
              : "";
            if (response.client.address.suburb) {
              this.suburb = {
                name: response.client.address.suburb,
              };
            } else {
              this.suburb = "";
            }
            this.form.city = response.client.address
              ? response.client.address.city
              : "";
            this.form.country = response.client.address
              ? response.client.address.country
              : "";
            this.form.state = response.client.address
              ? response.client.address.state
              : "";
            if (this.zones.length > 0 && response.client.zone) {
              if (
                this.user.role == "SAMPLER_SOLENA" ||
                this.user.role == "GEN_MANAGER"
              ) {
                let found = this.zones.find(
                  (element) => element._id == response.client.zone
                );
                this.form.zone = found;
              }
            }
            this.form.cultivableArea = response.client.cultivableArea || "";
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    }
  },
  watch: {
    async zipCode(value) {
      let response = await this.getZipCode(value);
      if (response.success != 0) {
        this.countryList = response.data;
      }
    },
    suburb(value) {
      if (value && value.province && value.state) {
        this.form.city = value.province;
        this.form.state = value.state;
      }
    },
  },
};
</script>

<style scoped>
.custom-tel-input {
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 4px !important;
  min-height: 40px !important;
  background-color: white !important;
  margin-top: 8px !important;
  margin-bottom: 12px !important;
  padding: 5px 12px !important;
  font-family: "Noto Sans", sans-serif !important;
  font-size: 14px !important;
}
.custom-tel-input:focus-within {
  border: 2px solid #238d27 !important;
  padding: 4px 11px !important; /* Ajuste por el borde de 2px */
}
/* Estilos internos de vue-tel-input */
::v-deep .vti__input {
  background: transparent !important;
  border: none !important;
}
</style>
